import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TurnkeySolutionsPage = lazy(() => import('../pages/turnkey-solutions/page'));
const WhoWeServePage = lazy(() => import('../pages/who-we-serve/page'));
const WhyMedilinePage = lazy(() => import('../pages/why-mediline/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CoverageAreasPage = lazy(() => import('../pages/coverage-areas/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const ServiceRequestPage = lazy(() => import('../pages/service-request/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/turnkey-solutions',
    element: <TurnkeySolutionsPage />,
  },
  {
    path: '/who-we-serve',
    element: <WhoWeServePage />,
  },
  {
    path: '/why-mediline',
    element: <WhyMedilinePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/coverage-areas',
    element: <CoverageAreasPage />,
  },
  {
    path: '/careers',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <CareersPage />
      </Suspense>
    ),
  },
  {
    path: '/service-request',
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <ServiceRequestPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
